"use client";
import Drawer from "@mui/material/Drawer";
import { MiniCart } from "page-sections/mini-cart";
import { useMiniCart } from "contexts/MiniCartContext";

export default function MiniCartDrawer() {

  const { open, setOpen } = useMiniCart();

  return (
    <Drawer
      open={open}
      anchor="right"
      onClose={() => setOpen(false)}
      sx={{
        zIndex: 9999
      }}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 12,
          borderBottomLeftRadius: 12
        }
      }}>
      <MiniCart />
    </Drawer>
  );
}